import { IPreference } from './../../../_models/transfer-sections/IPreference';
import { ToastrService } from 'ngx-toastr';
import { PreferenceService } from './../../../shared/services/preference.service';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-preference',
  templateUrl: './preference.component.html',
  styleUrls: ['./preference.component.css']
})
export class PreferenceComponent implements OnInit {
  @Input() preferences: IPreference[];
  @Output() onChangePreference = new EventEmitter();

  columns = [
    { title: 'Order', key: 'Order', isSortable: false },
    { title: 'School', key: 'VacantPostId', isSortable: false },
    { title: 'Type', key: 'VacancyTypeId', isSortable: false },
    {},
    {},
    {}
  ];

  constructor(
    private service: PreferenceService,
    private toastrService: ToastrService,) {
  }

  ngOnInit(): void {
  }

  delete(v) {
    if (!confirm('Are you sure you want to delete this preference?')) return;

    this.service.delete(v.id).subscribe(() => {
      this.toastrService.error('preference deleted successfully');
      this.onChangePreference.emit();
    });
  }

  up(v) {
    this.service.up(v).subscribe(() => {
      this.onChangePreference.emit();
    });
  }

  down(v) {
    this.service.down(v).subscribe(() => {
      this.onChangePreference.emit();
    });
  }
}
